function initialsOf(name) {
  const words = name.trim().split(/\s+/u).filter(Boolean);
  const first = words[0];
  if (!first) return "";
  const last = words.length > 1 ? words[words.length - 1] : void 0;
  const letter = (word) => Array.from(word)[0] ?? "";
  return (letter(first) + (last ? letter(last) : "")).toLocaleUpperCase();
}
export {
  initialsOf
};
//# sourceMappingURL=initials.js.map